export default function (context, val) {
    context.commit('set_form', {
        CurrencyId: val,
    });
    context.state.form.AgreementCodes.forEach(code => {
        context.dispatch('agreement_getCourse', code);
    });
}